let prefix = 'jwt-'


export function saveAuthToken(companyId, token) {    
    if(!companyId){
        return null
    }     
    localStorage.setItem(prefix + companyId, token)
}

export function getAuthToken(companyId) {    
    if(!companyId){
        return null
    }
     //localStorage.setItem('jwt-Ts87CUfRcGnpHssG35fgc91NXZmH', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjdXN0b21lcklkIjoiOTIyMTNmZGYtODc4MC00MWM2LTgyZjUtY2I0NmJhZGUzZDk3IiwiaWF0IjoxNzU5MDczNzE3LCJleHAiOjE3NTk5Mzc3MTd9.5cg4tLOEx8s9YwHJuww0t6bZ_O6yl9PWwqm-LqmzMlE')
    let jwt = localStorage.getItem(prefix + companyId)    
    return jwt || null
}

export function logout(companyId){
    if(companyId){
        localStorage.removeItem(prefix + companyId)
    }
}

